export default "/images/941bffe4a72255b4278925388f930c57.avif";